module.exports = __webpack_public_path__ + "media/app/assets/races/troll_male-c8b679a88ad5e85ba5e64df03327db94.png";